export default function NouvelleAnneeSteps({ step }: { step: number }) {
   return (
      <div className="container mx-auto p-4">
         <div className="text-center mb-8">
            <ul className="steps">
               <li className={step >= 0 ? "step step-primary" : "step"}>Introduction</li>
               <li className={step >= 1 ? "step step-primary" : "step"}>Nouvelle année</li>
               <li className={step >= 2 ? "step step-primary" : "step"}>Configurer les groupes</li>
            </ul>
         </div>
      </div>
   )
}
